import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
    selector: 'ms-onboarding-tooltip',
    templateUrl: './onboarding-tooltip.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingTooltipComponent {
    @Input() message: string;
    @Input() showHelp = false;
    @Output() closeClicked = new EventEmitter<void>();
    @HostBinding('class') className = `onboarding-tooltip`;
    @HostBinding('class.hidden') get hidden(): boolean {
        return !this.showHelp;
    }

    closeHelp(): void {
        this.showHelp = false;
        this.closeClicked.emit();
    }
}
